import { Box, Grid, Skeleton } from '@mui/material';

const ProductListSkeleton = () => <Grid container spacing={4}>
    {Array.from({ length: 8 }, (_, index) => <Grid key={index} item xxl={2.4} xl={3} lg={4} md={6} sm={6} xs={12}>
        <Box sx={{ border: '1px solid #e5e7eb', borderRadius: 2, p: 2 }}>
            <Skeleton variant="text" width="16%" sx={{ ml: 'auto' }} />
            <Skeleton variant="rectangular" height={220} sx={{ borderRadius: 1 }} />
            <Skeleton variant="text" width="75%" sx={{ mt: 1 }} />
            <Skeleton variant="text" width="45%" />
            <Skeleton variant="text" width="100%" />
            <Skeleton variant="text" width="80%" />
        </Box>
    </Grid>)}
</Grid>;

export default ProductListSkeleton;
